// extracted by mini-css-extract-plugin
export var bubble = "_1k-0";
export var container = "_1k-f";
export var contrastBorder = "_1k-g";
export var greyOut = "_1k-2";
export var initialsColor0 = "_1k-3";
export var initialsColor1 = "_1k-4";
export var initialsColor10 = "_1k-d";
export var initialsColor11 = "_1k-e";
export var initialsColor2 = "_1k-5";
export var initialsColor3 = "_1k-6";
export var initialsColor4 = "_1k-7";
export var initialsColor5 = "_1k-8";
export var initialsColor6 = "_1k-9";
export var initialsColor7 = "_1k-a";
export var initialsColor8 = "_1k-b";
export var initialsColor9 = "_1k-c";
export var initialsWrapper = "_1k-1";
export var large = "_1k-l";
export var medium = "_1k-k";
export var mediumSmall = "_1k-j";
export var mediumSmallMedium = "_1k-o";
export var micro = "_1k-h";
export var small = "_1k-i";
export var tiny = "_1k-n";
export var xTiny = "_1k-m";